<template>
    <svg
        id="icon_flypoker"
        xmlns="http://www.w3.org/2000/svg"
        width="21.979"
        height="20.896"
        viewBox="0 0 21.979 20.896"
    >
        <path
            id="Path_474"
            data-name="Path 474"
            d="M1832.136,37.873s3.815-1.116,5.169-6.169a10.166,10.166,0,0,1,5.688-6.688l7.13,7.129a12.761,12.761,0,0,0-5.329,7.329,9.383,9.383,0,0,1-5.437,6.437Z"
            transform="translate(-1832.136 -25.016)"
            fill="#854b97"
        />
        <path
            id="Subtraction_7"
            data-name="Subtraction 7"
            d="M1076.083-609.12h0l-.636-.709a9.629,9.629,0,0,0,4.075-5.729,12.817,12.817,0,0,1,3.17-5.551,11.319,11.319,0,0,1,2.159-1.778l-6.435-6.434a7.874,7.874,0,0,1,1.306-.695l7.129,7.129a12.849,12.849,0,0,0-5.329,7.33,9.817,9.817,0,0,1-3.224,5.105,8.139,8.139,0,0,1-2.213,1.332Z"
            transform="translate(-1064.871 630.016)"
            fill="#854b97"
        />
    </svg>
</template>
